import { Link, useNavigate } from "react-router-dom";
import Mascot from "../components/atoms/Mascot";
import Button from "../components/atoms/Button";
import Chip from "../components/atoms/Chip";

export default function NotFound() {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("currentUser");
  const home = isLoggedIn ? "/dashboard" : "/";

  function goBack() {
    if (window.history.length > 1) navigate(-1);
    else navigate(home);
  }

  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "48px 24px" }}>
      <div style={{ textAlign: "center", maxWidth: 520 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <Mascot size={200} mood="listening" />
        </div>
        <Chip tone="ink">404</Chip>
        <h1 className="font-display" style={{ fontSize: 56, lineHeight: 1.05, fontWeight: 400, margin: "16px 0 12px", letterSpacing: "-0.025em" }}>
          <em style={{ color: "var(--gold-500)" }}>Wrong turn.</em>
        </h1>
        <p style={{ fontSize: 17, color: "var(--fg-2)", lineHeight: 1.6, margin: "0 auto 28px", maxWidth: "44ch" }}>
          That page doesn't exist — or it moved. Penny's still listening, but she can't find it. Let's get you back somewhere useful.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <Link to={home} style={{ textDecoration: "none" }}>
            <Button variant="ink">{isLoggedIn ? "Back to dashboard" : "Back to home"}</Button>
          </Link>
          <button type="button" onClick={goBack} style={{ background: "transparent", color: "var(--fg-2)", border: 0, padding: "10px 18px", fontWeight: 600, fontSize: 14, cursor: "pointer", textDecoration: "underline" }}>
            ← Go back
          </button>
        </div>

        <div style={{ marginTop: 40, paddingTop: 24, borderTop: "1px solid var(--border-1)", textAlign: "left", maxWidth: 380, margin: "40px auto 0" }}>
          <p style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.14em", color: "var(--fg-3)", margin: "0 0 10px" }}>
            Try one of these
          </p>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 4 }}>
            {isLoggedIn ? (
              <>
                <FootLink to="/dashboard">Today's lesson</FootLink>
                <FootLink to="/conversations">Conversation scenarios</FootLink>
                <FootLink to="/mini-games">Mini games</FootLink>
                <FootLink to="/calendar">Your calendar</FootLink>
                <FootLink to="/achievements">Badges</FootLink>
              </>
            ) : (
              <>
                <FootLink to="/onboarding">Start free</FootLink>
                <FootLink to="/login">Sign in</FootLink>
                <FootLink to="/pricing">Pricing</FootLink>
                <FootLink to="/api-docs">API for developers</FootLink>
                <FootLink to="/contact">Contact</FootLink>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

function FootLink({ to, children }) {
  return (
    <li>
      <Link to={to} style={{ display: "block", padding: "8px 0", color: "var(--fg-1)", fontSize: 14, textDecoration: "none", borderBottom: "1px solid var(--border-1)" }}>
        {children} <span style={{ color: "var(--gold-600)", marginLeft: 4 }}>→</span>
      </Link>
    </li>
  );
}
